module.exports = __webpack_public_path__ + "static/media/5-7.0d6447dc.mp3";